import AuthService from '../../AuthService';
const partner = {
  getPartner(page){
      return AuthService.get(`/about/partner?page=${page}`);
  },
  showPartner(id){
     return AuthService.get(`/about/partner/${id}`);
  },
  createPartner(data){
    return AuthService.post(`/about/partner`,data);
  },
  updatePartner(id,data){
    return AuthService.put(`/about/partner/${id}`,data);
  },
  deletePartner(id){
    return AuthService.delete(`/about/partner/${id}`);
  },
}
export default partner
